import React, { useEffect, useState, useMemo,useCallback  } from 'react';
import { getAdminProjects, deleteAdminProject,toggleProjectStatus } from '../../services/adminApi'; // Assuming these API functions exist
import ReusableAdminTable from './ReusableAdminTable'; // Adjust path
import {deleteProjectApi,fetchProjectListApi } from '../../services/api';
import { useNavigate, Link } from 'react-router-dom';

// UI & Icons
import { Button, Badge } from 'react-bootstrap';
import { FiEdit, FiTrash2 } from 'react-icons/fi';

const AdminProjectList = () => {
    // State for projects
    const [projects, setProjects] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
      const [loading, setLoading] = useState(true);
      const [error, setError] = useState('');
    
     const navigate = useNavigate();

     const handleEdit = (projectId) => {
        if (!projectId) return alert("Project ID not found.");
        navigate(`/admin/post-projects/${projectId}`);
    };



    const handleAddNew = () => {
         navigate('/admin/post-projects');
    };

     
     const loadProjects = useCallback(async () => {
        setIsLoading(true);
        setError(''); // Clear previous errors
        try {
            // Assuming getAdminProjects() returns { data: [...] }
            const res = await getAdminProjects();
            if (res && res.data) {
                setProjects(res.data);
            } else {
                setProjects([]); // Ensure projects is an array if API returns unexpected
                setError('No projects found or API returned unexpected data.');
            }
        } catch (err) {
            console.error("Error fetching projects:", err);
            setError('Failed to load projects. Please try again later.');
            setProjects([]); // Clear projects on error
        } finally {
            setIsLoading(false);
        }
    }, []); 

    // --- Effect to load projects on component mount ---
    useEffect(() => {
        loadProjects();
    }, [loadProjects]); 


  // // ✅ DELETE PROJECT
 
 

    const handleDelete = async (projectIdToDelete) => {
        if (!projectIdToDelete) {
            alert("Invalid Project ID for deletion.");
            return;
        }
        if (window.confirm('Are you sure you want to delete this project? This may also affect associated roles.')) {
            try {
                await deleteProjectApi(`/projects/${projectIdToDelete}`); // Assuming this is correct for your api service
                alert('Project deleted successfully!');
                loadProjects();
            } catch (err) {
                console.error("Error deleting project:", err);
                alert('Deletion failed. Please check your connection or try again.');
            }
        }
    };

    const handleToggleStatus = async (id, status) => {
        try {
            let message = "";

            if (status === 'active') {
                message = "Do you want to deactivate this project?\nAll roles under this project will also be deactivated.";
            } else {
                message = "Do you want to activate this project?";
            }

            const confirmAction = window.confirm(message);

            if (!confirmAction) return; // ❌ cancel

            await toggleProjectStatus(id);
            loadProjects();

        } catch (err) {
            alert("Failed to update status");
        }
    };

    const columns = useMemo(() => [
        { accessorKey: 'id', header: 'ID' },
        { accessorKey: 'project_name', header: 'Project Title' },
        { accessorKey: 'project_type', header: 'Type' }, // e.g., Film, TVC
        {
            accessorKey: 'status',
            header: 'Status',
            cell: info => {
                const status = info.getValue();
                const variant = status === 'Completed' ? 'success' : status === 'Casting' ? 'primary' : 'secondary';
                return <Badge bg={variant}>{status}</Badge>;
            }
        },
        { accessorKey: 'creator.full_name', header: 'Casting Director' }, // Assumes backend JOINs this data

          {
            id: 'toggle',
            header: 'Control',
            cell: (info) => {
                const status = info.row.original.status;

                return (
                <Button
                    size="sm"
                    variant={status === 'active' ? 'success' : 'secondary'}
                    onClick={() => handleToggleStatus(info.row.original.id, info.row.original.status)}
                >
                    {status === 'active' ? 'Deactivate' : 'Activate'}
                </Button>
                );
            }
          },

            
        {
            id: 'actions',
            header: 'Actions',
            cell: (info) => (
                    <div className="d-flex justify-content-center gap-2">
                        
                      <Button variant="link" className="p-0 text-info" onClick={() => handleEdit(info.row.original.id)}>
                        <FiEdit />
                      </Button>
                      <Button variant="link" className="p-0 text-danger" onClick={() => handleDelete(info.row.original.id)}>
                        <FiTrash2 />
                      </Button>
                    </div>
            ),
        }
    ], []);

    return (
        <ReusableAdminTable
            data={projects}
            columns={columns}
            isLoading={isLoading}
            title="Project Management"
            onAddNew={handleAddNew}
            addNewButtonText="Add Project"
            searchPlaceholder="Search projects..."
            exportCsvFilename="projects.csv"
        />
    );
};

export default AdminProjectList;
